$(function() {
	if (!$body.hasClass('single-special') && !$body.hasClass('single-shop'))
		return;

	var slider = $('.single_special_hero .slider');
	var slides = slider.find('.slide');

	initializeSlick($('.single_special_hero .slider'), {
		accessibility: true,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		arrows: true,
		autoplay: false,
		fade: true,
		pauseOnFocus: true,
		pauseOnHover: false,
		nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
		focusOnSelect: true,
	}, function() {
		$('.single_special_hero .slider').on('beforeChange', function() {
			$('.single_special_hero .darken').addClass('hide');
			$('.single_special_hero .darken_alternate').addClass('show');
			$('.single_special_hero .title').addClass('hide');
		});
	});

	$('.single_special_hero .slider').on('afterChange', function(e, slick) {
		slides.eq(0).removeClass('initial_load');
		slides.removeClass('current_slide').eq(slick.currentSlide).addClass('current_slide');
	});

	$(window).on('panelsLoaded', function() {
		setTimeout(function() {
			slides.eq(0).addClass('initial_load');
			if (window.currentSlidersState != 2) {
				slider.slick('slickPlay');
			} else {
				slider.data('autoplay', 1);
			}	
		}, 500);
	});
});